import { useState, useMemo } from "react";
import MapView from 'components/MapView'
import { Container } from "@mui/material";
import DefaultLayout from 'layout/DefaultLayout';
import useMapTracking from "hooks/useMapTracking";
import OrderDetails from 'components/OrderDetails';
import {HAS_NOT_TRACK_PROVIDER, StatusName} from "config/config";
import {
  TrackingMapArea,
  TrackingSidebarWrapper,
  // OrderDetailsFooterTitle,
  // OrderDetailsFooter,
  TrackingOrderDetailsWrapper
} from "layout/styles";
import Preloader from "components/Preloader/Preloader";

const sxContainer = {
  container: {
    maxWidth: '1240px',
    px: { xs: 2, sm: 3, md: 4 },
    '@media (max-width: 480px)': {
      px: 2
    }
  }
}

function App() {
  const [loading, setLoading] = useState(true);
  const {
    queryTrackUrl,
    activeOrderStep,
    orderInfo,
    activeOrderStatus,
    queryOcoExternalId,
    trackingUrl,
    canceledByDelivery,
    canceledByProvider,
  } = useMapTracking(setLoading);


  const cacheStyle = useMemo(() => {
    return {
      boxShadow: activeOrderStatus === StatusName.rejected ||
        activeOrderStatus === StatusName.closed ||
        activeOrderStatus === StatusName.canceled  ?
       'none' : '0 4px 20px rgba(0, 0, 0, 0.08)',
      border: activeOrderStatus === StatusName.rejected ||
       activeOrderStatus === StatusName.closed ||
       activeOrderStatus === StatusName.canceled  ?
       'none' : '1px solid #f5f5f5',
      backgroundColor: activeOrderStatus === StatusName.rejected ||
      activeOrderStatus === StatusName.closed ||
       activeOrderStatus === StatusName.canceled  ?
       'transparent' : '#ffffff',
    }
  }, [activeOrderStatus])

  const isCancelled = useMemo(() => {
    return activeOrderStatus === StatusName.rejected ||
      activeOrderStatus === StatusName.canceled ||
      // activeOrderStatus === StatusName.canceled_from_provider ||
      activeOrderStatus === StatusName.closed
  }, [activeOrderStatus])


  if (loading) {
    return  <Preloader overlay={true} />
  }

  return (
    <DefaultLayout>
      <Container sx={sxContainer}>
        <TrackingOrderDetailsWrapper>
          {isCancelled ? (
            <></>
          ) : (
            <TrackingSidebarWrapper>
              <OrderDetails
                orderInfo={orderInfo}
                activeOrderStep={activeOrderStep}
                trackUrl={queryTrackUrl}
                activeOrderStatus={activeOrderStatus}
                queryOcoExternalId={queryOcoExternalId}
                hideOrderDetailsSection={true}
              />
          </TrackingSidebarWrapper>
          )}
          
          {orderInfo.provider !== HAS_NOT_TRACK_PROVIDER.doordash && (
            <TrackingMapArea sx={cacheStyle}>
              <MapView 
                trackUrl={trackingUrl} 
                activeOrderStatus={activeOrderStatus}
                orderInfo={orderInfo}
                queryOcoExternalId={queryOcoExternalId}
                showOrderDetails={!!trackingUrl}
                canceledByDelivery={canceledByDelivery}
                canceledByProvider={canceledByProvider}
              />
            </TrackingMapArea>
          )}
        </TrackingOrderDetailsWrapper>
        {/* <OrderDetailsFooter>
          <Typography variant="caption" color="textSecondary">
            Powered by
          </Typography>
          <OrderDetailsFooterTitle variant="caption">
            Orders.Co
          </OrderDetailsFooterTitle>
        </OrderDetailsFooter> */}
      </Container>
    </DefaultLayout>
  );
}

export default App;
